import axios from "axios";
import { getAdminToken } from "../utils/adminAuth";

export const statsAPI = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/stats/`,
});
statsAPI.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers["X-Admin-Token"] = token;
  return config;
});
